import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/orden_trabajo/getAllOrdenesTrabajo.php';

export default function getAllOrdenesTrabajo({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}